import React, { ReactNode } from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { WorkOtherTitleDTO } from '../../../../api/core/models';
import { Actions, MultiInputControls } from 'pages/components/form/MultiInput/MultiInputControls';
import { getDefaultWorkOtherTitle } from '../../../../Settings/emptyModels';
import { ValidationResult } from '../../../../util/validation/interfaces';
import { CheckPermissionFunction } from '../../../../Auth/components/PermissionGate';
import { Panel } from '../layout/Panel';
import { InputGroup } from '../layout/InputGroup';
import { LabelledDropdown } from '../../../components/form/LabelledDropdown';
import { LabelledInputText } from '../../../components/form/LabelledInputText';
import { getVocabularyOptions } from '../../../../Vocabulary/util';


interface WorkOtherTitlesProps {
  workOtherTitles?: WorkOtherTitleDTO[];
  listPartition: string;
  onChange: (data: any) => void;
  checkPermission: CheckPermissionFunction;
  validation: ValidationResult;
  autoFocus: boolean;
}

export function WorkOtherTitles(props: WorkOtherTitlesProps): ReactNode {
  const intl: IntlShape = useIntl();
  return (
    <Panel title={'work.attr.otherTitles'} toggleable={true} collapsed={true}>
      <MultiInputControls<WorkOtherTitleDTO>
        canEdit={props.checkPermission().canWrite}
        lines={props.workOtherTitles}
        onChange={props.onChange}
        addNew={(rows: WorkOtherTitleDTO[]): number => rows.push(getDefaultWorkOtherTitle())}
        renderLines={(
          workOtherTitle: WorkOtherTitleDTO,
          onLineChange: (newValues) => void,
          actions: Actions,
          idx: number
        ): ReactNode => {
          return (
            <InputGroup
              delete={{
                action: actions.delete,
                disabled: !props.checkPermission().canWrite,
              }}
            >
              <LabelledInputText
                id={'workOtherTitle_title'}
                autoFocus={props.autoFocus}
                label={`work.attr.otherTitle.attr.title`}
                value={workOtherTitle.otherTitle}
                onChange={(otherTitle: string): void => onLineChange({ ...workOtherTitle, otherTitle })}
                permissions={props.checkPermission('other_title')}
                validation={props.validation?.children[idx]?.fields?.other_title}
              />
              <LabelledDropdown
                id={'workOtherTitle_language'}
                onChange={(language: string): void => onLineChange({ ...workOtherTitle, language })}
                label={`work.attr.otherTitle.attr.language`}
                value={workOtherTitle.language}
                permissions={props.checkPermission('language')}
                validation={props.validation?.children[idx]?.fields?.language}
                options={getVocabularyOptions(intl.locale, 'language_list', props.listPartition)}
              />
            </InputGroup>
          );
        }}
      />
    </Panel>
  );
}
